import * as React from "react";
import { style } from "typestyle";
import { layout } from "./layout.js";
import { typography } from "./typography.js";
import { classNames } from "./utils.js";
import { View, ViewContent } from "./view.js";
const messageStyle = style({
    maxWidth: "26em",
    alignSelf: "center",
});
export function MessageView({ message, children, className, messageClassName }) {
    return (React.createElement(View, { className: className },
        React.createElement(ViewContent, { className: classNames(layout.vertical, layout.center) },
            React.createElement("div", { className: classNames(messageStyle, messageClassName) },
                React.createElement("p", { className: classNames(typography.title, typography.alignCenter) }, message),
                React.createElement("div", { className: classNames(layout.horizontal, layout.spaceBetween) }, children)))));
}
//# sourceMappingURL=MessageView.js.map